import {BaseFormModel} from './base-form-model';
import {MenuModifierSelection} from './menu-modifier-selection';
import {MenuModifierGroupSelectionOption} from './menu-modifier-group-selection-option';

export class MenuModifierGroupSelection extends BaseFormModel<MenuModifierGroupSelection> {
    id: number;
    menuModifierSelection: MenuModifierSelection;
    options: MenuModifierGroupSelectionOption[];
    sortOrder: number;
}
